import React from 'react';
import {SvgIcon} from "@material-ui/core";

const DashboardIcon = (props) => {
  return(
    <SvgIcon {...props}>
      <path d="M7.33268 0.666504H1.99935C1.26297 0.666504 0.666016 1.26346 0.666016 1.99984V7.33317C0.666016 8.06955 1.26297 8.6665 1.99935 8.6665H7.33268C8.06906 8.6665 8.66602 8.06955 8.66602 7.33317V1.99984C8.66602 1.26346 8.06906 0.666504 7.33268 0.666504Z" stroke="white"/>
      <path d="M17.9993 0.666504H12.666C11.9296 0.666504 11.3327 1.26346 11.3327 1.99984V7.33317C11.3327 8.06955 11.9296 8.6665 12.666 8.6665H17.9993C18.7357 8.6665 19.3327 8.06955 19.3327 7.33317V1.99984C19.3327 1.26346 18.7357 0.666504 17.9993 0.666504Z" stroke="white"/>
      <path d="M17.9993 11.3332H12.666C11.9296 11.3332 11.3327 11.9301 11.3327 12.6665V17.9998C11.3327 18.7362 11.9296 19.3332 12.666 19.3332H17.9993C18.7357 19.3332 19.3327 18.7362 19.3327 17.9998V12.6665C19.3327 11.9301 18.7357 11.3332 17.9993 11.3332Z" stroke="white"/>
      <path d="M7.33268 11.3332H1.99935C1.26297 11.3332 0.666016 11.9301 0.666016 12.6665V17.9998C0.666016 18.7362 1.26297 19.3332 1.99935 19.3332H7.33268C8.06906 19.3332 8.66602 18.7362 8.66602 17.9998V12.6665C8.66602 11.9301 8.06906 11.3332 7.33268 11.3332Z" stroke="white"/>
    </SvgIcon>
  );
}

const PaymentIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" stroke="white"></path>
    </SvgIcon>
  );
}

const IconUI = (props) =>  {
  switch(props.icon) {
    case "dashboard":  return <DashboardIcon {...props} />;
    case "payment":  return <PaymentIcon {...props}/>
    default:  return <h1 {...props}></h1>;
  }
}

export default IconUI;
